import { Asset } from '../../common/model/Assets';
export default class ObjectiveItem {
    static fromPartial(partial) {
        var _a, _b, _c, _d;
        const objective = new ObjectiveItem();
        const translation = (_a = partial.translations) === null || _a === void 0 ? void 0 : _a.pop();
        objective.title = (_b = translation === null || translation === void 0 ? void 0 : translation.title) !== null && _b !== void 0 ? _b : '';
        objective.color = (_c = partial.color) !== null && _c !== void 0 ? _c : '';
        objective.number = (_d = partial.number) !== null && _d !== void 0 ? _d : 0;
        if (translation === null || translation === void 0 ? void 0 : translation.image)
            objective.image = new Asset(translation === null || translation === void 0 ? void 0 : translation.image);
        return objective;
    }
}
